import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { get as lodashGet } from 'lodash';
import { getKvImageList } from 'src/actions/kvImageList';
import couponListMainImg from 'src/assets/kv.jpg';

const KvImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
`;

const KvImageList = () => {
  const dispatch = useDispatch();

  const kvImageListData = useSelector((state) => state.ajax.kvImageList);

  /** @type {import('../../../types/kv').Kv[]} */
  const kvImageList = lodashGet(kvImageListData, ['data'], []);

  useEffect(() => {
    dispatch(getKvImageList());
  }, [dispatch]);

  const firstImageUrl = kvImageList?.length > 0 ? kvImageList[0]?.imageUrl : couponListMainImg;

  return <KvImage src={firstImageUrl} alt="KV Image" />;
};

export default KvImageList;
